import React, { useEffect } from "react";

import { useSelector } from "react-redux";

import { useCompany } from "@/hooks/util/useCompany";
import { selectAllBreadcrumbs } from "@/store/page/page";

export interface DocumentTitleProps {
  siteTitle: string;
}

export const DocumentTitle: React.FC<DocumentTitleProps> = ({ siteTitle }) => {
  const breadcrumbs = useSelector(selectAllBreadcrumbs);
  const { selectedCompany } = useCompany();

  useEffect(() => {
    const parts = [];

    // Add siteTitle first
    parts.push(siteTitle);

    // Add breadcrumbs second
    breadcrumbs.forEach((breadcrumb) => {
      parts.push(breadcrumb.title);
    });

    // Add company name if available, but last
    if (selectedCompany?.name) {
      parts.push(selectedCompany.name);
    }

    document.title = parts.join(" - ");
  }, [siteTitle, breadcrumbs, selectedCompany]);

  return null;
};
